/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.CultureSettings {
    "use strict";
    
    export class CultureSettingsContext extends Meevo.Components.CommonClasses.CommonContextBase {
        protected abcultureinfo:any;
        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService
        ) {
            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.cultureSettings;
            this.sectionTemplatePath = "app/plugins/cultureSettings/sectionViews/";
            this.initializeSections();
            this.buildCrudSecurityKeysBase(this.securityKeys.BUSINESSINFO_CULTURESETTINGS_TAB_MAIN);
        }
     
        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.BUSINESSINFO_CULTURESETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0,
                    "SECTION_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    Model.NounEnum.CulturalSettingsMain,
                    this.identityService,
                    this.appSettings,
                    this.securityKeys.BUSINESSINFO_CULTURESETTINGS_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ));
            }
            this.activate();
        }

        initializeHeader(model: any): void {
            let businessInfo = <Meevo.Model.BusinessInfo>model;
            this.headerContent = businessInfo.storeName;

        }

        postUpdate(model: any): void {
            super.postUpdate(model);

            const request = { 
                criteria: { 
                    currency: model.currencyCodeEnum
                }
            };

            this.dataService.getListPaged("denomination", request).then((response: Meevo.Model.Denomination[]) => {
                let denominations = _(response).filter(d => d.isCashRoundingDefault);

                this.dataService.customMethodData("api/tax", "get", null).then((response) => {
                    let tax : Meevo.Model.Tax = response.data;
    
                    tax.cashRoundingInterval = (denominations.length === 0)
                        ? null
                        : denominations[0].moneyAmount;

                    const countryIdEnum = this.sections.filter(s => s.displayNameContentKey === "SECTION_MAIN")[0].model.countryEnum;
                    if (countryIdEnum === Meevo.Model.CountryIdEnum.en_au || countryIdEnum === Meevo.Model.CountryIdEnum.en_nz)
                        tax.isTaxIncludedInPrice = true;

                    this.dataService.customMethodData("api/tax", "post", tax);
                });
            });
        }                
    }
}